<template lang="pug">
  form-card.mb-2(
  :title="titlePrefix + $i18n.t('db.models.usuario_grupo')"
  :invalid='invalid'
  :resource='current'
  :loading='loading'
  )
    div(v-if='current')
      .columns
        .column.col-6
          form-group(:label="$i18n.tModel('usuario_grupo.nome')" :validation='$v.current.nome')
            input.form-input(type='text' v-model='$v.current.nome.$model' :placeholder="$i18n.tModel('usuario_grupo.nome')")
    div(slot='footer' v-if='current')
      btn-logs(
        v-if='current.id'
        entityName='UsuarioGrupo'
        :entityId='current.id'
        v-acl:allowed.admin.logs.index
      )
      button.btn.btn-primary(@click="save" :class="{loading: loading}" :disabled='invalid || loading') {{$i18n.t('views.buttons.save.label')}}
</template>

<script>
import UsuarioGrupo from '@/models/UsuarioGrupo'
import formMixin, { vuexDefaultMapping } from '@/mixins/form'

export default {
  mixins: [formMixin],
  vuex: { usuarioGrupos: vuexDefaultMapping },

  validations: {
    current: UsuarioGrupo.validations,
  },

  methods: {
    newModel(usuarioGrupo) {
      return new UsuarioGrupo(usuarioGrupo)
    },
  },
}
</script>
